import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Role } from '@models/account/role.model';

@Component({
    selector: 'app-settings-role-create-form',
    templateUrl: './role-create.template.html',
    styleUrls: ['./role-create.style.scss'],
})
export class RoleCreateForm extends BaseForm {
    @Input() role: Role = new Role();

    showSetup = true;

    newRole(type: string): void {
        switch (type) {
            case 'admin':
                this.role.cloneRole = 'admin';
                break;
            case 'manager':
                this.role.cloneRole = 'manager';
                break;
            case 'employee':
                this.role.cloneRole = 'employee';
                break;
            case 'scratch':
                break;
        }
        this.showSetup = false;
    }
}
